import * as React from 'react';
import { IMotiveTextInfo } from './dtp-resources.controller';
import * as CopyToClipboard from 'react-copy-to-clipboard';

export interface IDtpResourcesTextsProps {
    texts: IMotiveTextInfo[];
}

export const DtpResourcesTexts = (props: IDtpResourcesTextsProps) => {
    return (
        <div className="motive-texts">
        {props.texts.map((item, index) =>
            <div className={"text-item "} key={'div-' + index}>
                <div className="text-value">
                    <div>&quot;{item.text}&quot;</div>
                    <div>
                        Font: {item.font},
                        Color: <div className="color-icon" style={{backgroundColor: item.color}}></div> {item.color},
                        Is Bold: {item.isBold ? 'Yes' : 'No'},
                        Is Italic: {item.isItalic ? 'Yes' : 'No'}</div>
                </div>
                <div className="copy">
                    <CopyToClipboard text={item.text} >
                        <button>Copy to clipboard</button>
                    </CopyToClipboard>
                </div>
            </div>
        )}
    </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/dtp-resources/dtp-resources-texts.component.tsx